import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './Views/home/home.component';
import { DashboardComponent } from './Views/dashboard/dashboard';
import { OrderComponent } from './Views/order/order.component';
import { NewOrderDialog } from './dialogs/neworder/neworder';
import { IndatasComponent } from './Views/ActiveContracts/ActiveContracts';
import { ChecklistRepurchaseDialog } from './dialogs/ChecklistRepurchaseDialog/ChecklistRepurchaseDialog';
import { ChecklistSoldDialog } from './dialogs/ChecklistSoldDialog/ChecklistSoldDialog';
import { ChecklistTerminationDialog } from './dialogs/ChecklistTerminationDialog/ChecklistTerminationDialog';
import { IntegrationLogs } from './components/IntegrationLogs/IntegrationLogs';

// Widgets
import { OrderFlowDBWidget } from './widgets/OrderFlow/orderflow';
import { ExpiringContractsDBWidget } from './widgets/ExpiringContracts/expiringContracts';

import { T4CommonModule} from '../../t4common/t4common';
import { AuthGuard, T4coreModule, SystemRights, UIService } from 't4core';
import { DataExportComponent } from './Views/dataExport/dataExport';
import { MapComponent } from './Views/map/map.component';
import { CustomerInfo } from './components/CustomerInfo/CustomerInfo.component';
import { T4PricesComponent } from './components/T4Prices/T4Prices';
import { TerminationDialog } from './dialogs/TerminationDialog/TerminationDialog';
import { Customers } from './Views/Customers/Customers';
import { ContractDialog } from './dialogs/ContractDialog/ContractDialog';
import { BackofficeComponent } from './Views/BackOffice/Backoffice';
import { BackofficeDashboardComponent } from './Views/BackOfficeDashboard/BackofficeDashboard';
import { CustomerSettings } from './components/CustomerSettings/CustomerSettings';
import { NewCustomerDialog } from './dialogs/NewCustomerDialog/NewCustomerDialog';
import { AddCostsDialog } from './dialogs/AddCostsDialog/AddCostsDialog';
import { InsuranceSetOffComponent } from './Views/InsuranceSetOff/InsuranceSetOff';
import { OffRentComponent } from './Views/OffRent/OffRent';
import { InvoiceComponent } from './Views/CommandCenter/Invoices/Invoices';
import { OrderService } from './Services/order.service';
import { InvoiceDetailsDialog } from './dialogs/InvoiceDetails/InvoiceDetails';
import { ContextTreeComponent } from '../Settings/views/ContextTree/ContextTree.component';
import { ContextDialog } from './dialogs/ContextDialog/ContextDialog';
import { Pricelists } from './Views/Pricelists/Pricelists';
import { EditPricelistComponent } from './Views/EditPricelist/EditPricelist';
import { EntityLogs } from './Views/EntityLogs/EntityLogs';
import { PayThroughCustomerComponent } from './Views/PayThrough/PayThrough';
import { StakeholderSettings } from './components/StakeholderSettings/StakeholderSettings';
import { AddStakehholderDialog } from './dialogs/AddStakeholder/AddStakeholder';
import { InvoicesComponent } from './Views/Invoices/Invoices.component';
import { CreditInvoiceDialog } from './dialogs/CreditInvoiceDialog/CreditInvoiceDialog';
import { OrderItemComponent } from './Views/Items/Items';
import { SubscriptionComponent } from './components/Subscription/Subscription';
import { AddSubscriptionDialogComponent } from './dialogs/AddSubscription/AddSubscriptionDialog';
import { GroupMappingDialogComponent } from './dialogs/GroupMappingDialog/GroupMappingDialog';


@NgModule({
    declarations: [
        DashboardComponent,
        HomeComponent,
        OrderComponent,
        IndatasComponent,
        NewOrderDialog,
        DataExportComponent,
        MapComponent,
        CustomerInfo,
        ContractDialog,
        TerminationDialog,
        NewCustomerDialog,
        Customers,
        BackofficeComponent,
        CustomerSettings,
        OrderFlowDBWidget,
        ExpiringContractsDBWidget,
        AddCostsDialog,
        AddStakehholderDialog,
        BackofficeDashboardComponent,
        InsuranceSetOffComponent,
        OffRentComponent,
        InvoiceComponent,
        T4PricesComponent,
        ContextTreeComponent,
        InvoiceDetailsDialog,
        ContextDialog,
        Pricelists,
        EditPricelistComponent,
        ChecklistRepurchaseDialog,
        ChecklistSoldDialog,
        ChecklistTerminationDialog,
        IntegrationLogs,
        EntityLogs,
        PayThroughCustomerComponent,
        ContextDialog,
        StakeholderSettings,
        InvoicesComponent,
        CreditInvoiceDialog,
        SubscriptionComponent,
        AddSubscriptionDialogComponent,
    OrderItemComponent,
    GroupMappingDialogComponent
    ],
    imports: [
        T4CommonModule,
        T4coreModule.forRoot({ dialogs: [] }),
        RouterModule.forRoot([
            {
                path: 'TurboOrder',
                canActivate: [AuthGuard],
                data: { index: 500, title: "Order", toolTip: "", roles: ['Sales'], icon: 'shopping_cart' },
                children: [
                    { path: '', redirectTo: 'Dashboard', pathMatch: 'full' },
                    {
                        path: "Dashboard",
                        canActivate: [AuthGuard],
                        component: DashboardComponent,
                        data: { title: "Dashboard", toolTip: "Sales at a glance", roles: ['Sales'], icon: 'bar_chart' }
                    },
                    {
                        path: "Order/:Id",
                        canActivate: [AuthGuard],
                        component: OrderComponent,
                        data: { hidden: true, roles: ['Sales', 'Backoffice'] }
                    },
                    {
                        path: "Backoffice",
                        canActivate: [AuthGuard],
                        data: { title: "Backoffice", toolTip: "Backoffice", roles: ['OneWayAdmin', 'Sales', 'Backoffice'], icon: 'bar_chart' },
                        children: [
                          { path: '', redirectTo: 'Offrent', pathMatch: 'full' },
                            {
                                path: "Offrent",
                                canActivate: [AuthGuard],
                                component: BackofficeComponent,
                                data: { title: "Offrent", toolTip: "Offrent", roles: ['OneWayAdmin', 'Sales'], icon: 'bar_chart' },
                            }
                        ]
                    },
                    {
                        path: "CommandCenter",
                        canActivate: [AuthGuard],
                        data: { title: "CommandCenter", toolTip: "Backoffice", roles: ['Backoffice'], icon: 'settings' },
                        children: [
                            { path: '', redirectTo: 'Invoices', pathMatch: 'full' },
                            {
                                path: "Invoices",
                                canActivate: [AuthGuard],
                                component: InvoiceComponent,
                                data: { title: "Invoices", roles: ['Backoffice'], icon: 'receipt' }
                            }
                        ]
                    },
                    {
                        path: "Sales",
                        canActivate: [AuthGuard],
                        data: { title: "My sales", roles: ['Sales'], icon: 'list_alt' },
                        children: [
                            { path: '', redirectTo: 'OffRent', pathMatch: 'full' },
                            {
                                path: "OffRent",
                                canActivate: [AuthGuard],
                                component: OffRentComponent,
                                data: { title: "Expiring contracts", roles: ['Sales'], icon: 'last_page' }
                            },
                            {
                                path: "Orders",
                                canActivate: [AuthGuard],
                                component: HomeComponent,
                                data: { title: "Orders", roles: ['Sales'], icon: 'list_alt' }
                            },
                            {
                                path: "Map",
                                canActivate: [AuthGuard],
                                component: MapComponent,
                                data: { title: "Map", roles: ['Sales'], icon: 'map' },
                            }
                        ]
                    },
                    {
                        path: "Customer",
                        canActivate: [AuthGuard],
                        data: { title: "Customers", roles: ['Sales'], icon: 'business' },
                        children: [
                            { path: '', redirectTo: 'List', pathMatch: 'full' },
                            {
                                path: "List",
                                canActivate: [AuthGuard],
                                component: Customers,
                                data: { title: "Customers", roles: ['Sales'], icon: 'business' }
                            },
                            {
                                path: "Map",
                                canActivate: [AuthGuard],
                                component: MapComponent,
                                data: { title: "Map", toolTip: "Map", roles: ['Sales'], icon: 'map' }
                            },
                            {
                              path: "Pricelists",
                              canActivate: [AuthGuard],
                              component: Pricelists,
                              data: { title: "Pricelists", roles: ['Sales'], icon: 'money' }
                            },
                            {
                              path: "EntityLogs",
                              canActivate: [AuthGuard],
                              component: EntityLogs,
                              data: { title: "Integration logs", roles: ['Sales', 'Backoffice'], icon: 'history' }
                          },
                          {
                            path: "PayThrough",
                            canActivate: [AuthGuard],
                            component: PayThroughCustomerComponent,
                            data: { title: "PayThrough", roles: ['Sales', 'Backoffice'], icon: 'price_check' }
                          },
                          {
                            path: "Items",
                            canActivate: [AuthGuard],
                            component: OrderItemComponent,
                            data: { title: "Item and products", roles: ['Admin', 'Backoffice', 'Sales'], icon: 'more' }
                          },
                        ]
                    },
                    {
                        path: "Customer/:Id",
                        canActivate: [AuthGuard],
                        component: IndatasComponent,
                        data: { hidden: true, roles: ['Sales'] }
                    }, {
                        path: "Reports",
                        canActivate: [AuthGuard],
                        component: DataExportComponent,
                        data: { title: "Reports", toolTip: "Reports", roles: ['Sales'], icon: 'bar_chart' }
                    },
                    {
                        path: "Insurance",
                        canActivate: [AuthGuard],
                        data: {
                            title: "Insurance", rights: SystemRights.TO_Insurance_Manage, icon: 'supervised_user_circle'
                        },
                        children: [
                            { path: '', redirectTo: 'Setoff', pathMatch: 'full' },
                            {
                                path: "Setoff",
                                canActivate: [AuthGuard],
                                component: InsuranceSetOffComponent,
                                data: {
                                    title: "Insurance set off", rights: SystemRights.TO_Insurance_Manage, icon: 'supervised_user_circle'
                                }
                            }
                        ]
                    },
                    {
                      path: "ContextTree",
                      canActivate: [AuthGuard],
                      component: ContextTreeComponent,
                      data: { title: "Context Tree", toolTip: "Context Tree", roles: ['Admin','Backoffice'], icon: 'supervised_user_circle', color: 'accent2' }
                     },
                    {
                      path: "Pricelists/:Id",
                      canActivate: [AuthGuard],
                      component: EditPricelistComponent,
                      data: { hidden: true, roles: ['Sales'] }
                    }
                ]
            },
        ])
    ],
    providers: [
        T4CommonModule,
      OrderService,
      { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }]
})
export class TurboOrder { }

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [
        { key: "T4.Order.InvoiceDialog", dialog: InvoiceDetailsDialog },
        { key: "T4.Order.GroupMappingDialog", dialog: GroupMappingDialogComponent }
      ]
    });
  };
}
// Module initialization
